import { render, staticRenderFns } from "./BindFirst.vue?vue&type=template&id=f234d3c4&"
import script from "./BindFirst.vue?vue&type=script&lang=ts&"
export * from "./BindFirst.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BindFirst.vue"
export default component.exports